// src/components/Admin/tabs/DogsTab.jsx
import React from 'react';

const DogsTab = ({ dogs, onDeleteDog }) => (
  <div className="bg-white rounded-2xl border border-[#3A2A20]/10 overflow-hidden">
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-[#3A2A20]/10 text-sm">
        <thead className="bg-[#EFE6DD]/60">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Perro</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Dueño</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Raza</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Edad</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Peso</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Sexo</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Esterilizado</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Vacunado</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Necesidades especiales</th>
            <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Acción</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#3A2A20]/10">
          {dogs.map((d) => (
            <tr key={d._id}>
              <td className="px-4 py-3 font-medium text-[#3A2A20]">
                <div className="flex items-center gap-2.5">
                  {d.image ? (
                    <img src={d.image} alt={d.name} className="h-8 w-8 rounded-full object-cover" />
                  ) : (
                    <div className="h-8 w-8 rounded-full bg-[#EFE6DD] flex items-center justify-center text-[10px] text-[#3A2A20]/40">
                      —
                    </div>
                  )}
                  {d.name}
                </div>
              </td>
              <td className="px-4 py-3 text-[#3A2A20]/70">
                <p>{d.owner?.fullname || '—'}</p>
                <p className="text-xs text-[#3A2A20]/40">{d.owner?.email}</p>
              </td>
              <td className="px-4 py-3 text-[#3A2A20]/70">{d.breed || '—'}</td>
              <td className="px-4 py-3 text-[#3A2A20]/70">{d.age != null ? `${d.age} años` : '—'}</td>
              <td className="px-4 py-3 text-[#3A2A20]/70">{d.weight != null ? `${d.weight} kg` : '—'}</td>
              <td className="px-4 py-3 text-[#3A2A20]/70">
                {d.gender === 'M' ? 'Macho' : d.gender === 'F' ? 'Hembra' : '—'}
              </td>
              <td className="px-4 py-3">
                <span
                  className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${
                    d.isNeutered ? 'bg-[#3A6B4C]/10 text-[#3A6B4C]' : 'bg-[#3A2A20]/5 text-[#3A2A20]/50'
                  }`}
                >
                  {d.isNeutered ? 'Sí' : 'No'}
                </span>
              </td>
              <td className="px-4 py-3">
                <span
                  className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${
                    d.isVaccinated ? 'bg-[#3A6B4C]/10 text-[#3A6B4C]' : 'bg-[#9A0002]/10 text-[#9A0002]'
                  }`}
                >
                  {d.isVaccinated ? 'Sí' : 'No'}
                </span>
              </td>
              <td className="px-4 py-3 text-[#3A2A20]/70 max-w-[200px]">
                {d.specialNeeds ? (
                  <span className="italic">{d.specialNeeds}</span>
                ) : (
                  <span className="text-[#3A2A20]/30">Ninguna</span>
                )}
              </td>
              <td className="px-4 py-3">
                <button
                  onClick={() => onDeleteDog(d._id)}
                  className="px-3 py-1.5 text-xs font-medium bg-[#9A0002]/10 text-[#9A0002] rounded-lg hover:bg-[#9A0002]/20 transition whitespace-nowrap"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {dogs.length === 0 && (
      <p className="text-sm text-[#3A2A20]/40 text-center py-10">Aún no hay perros registrados.</p>
    )}
  </div>
);

export default DogsTab;